import axios from '@axios'

const PREFIX = '/notificacoes'

export default {
  criaNotificacao(notificacao) {
    return axios.post(`${PREFIX}/cria-notificacao`, notificacao)
  },
  criaGrupoNotificacao(notificacao) {
    return axios.post(`${PREFIX}/cria-grupo-notificacao`, notificacao)
  },
  atualizaNotificacao(notificacaoId, notificacao) {
    return axios.put(`${PREFIX}/atualiza-notificacao/${notificacaoId}`, notificacao)
  },
  atualizaGrupoNotificacao(notificacaoId, notificacao) {
    return axios.put(`${PREFIX}/atualiza-grupo-notificacao/${notificacaoId}`, notificacao)
  },
  getNotificacoesPaginado(page, pageSize, filtros) {
    return axios.post(`${PREFIX}/busca-notificacoes-paginado?page=${page}&pageSize=${pageSize}`, filtros)
  },
  getNotificacaoById(id) {
    return axios.get(`${PREFIX}/busca-notificacao/${id}`)
  },
  getGrupoNotificacaoById(id) {
    return axios.get(`${PREFIX}/busca-grupo-notificacao/${id}`)
  },
  getNotificacoesUsuario(page, pageSize, filtros) {
    return axios.post(`${PREFIX}/busca-notificacoes-usuario?page=${page}&pageSize=${pageSize}`, filtros)
  },
  marcarComoLida(id) {
    return axios.post(`${PREFIX}/marcar-como-lida/${id}`)
  },
  getNotificacoesUsuarioNaoLidas() {
    return axios.get(`${PREFIX}/notificacoes-nao-lidas`)
  },
  deleteNotificacoes(id) {
    return axios.delete(`${PREFIX}/deleta-notificacao/${id}`)
  },
  deleteGrupoNotificacoes(id) {
    return axios.delete(`${PREFIX}/deleta-grupo-notificacao/${id}`)
  },
  getEventosNotificacoes() {
    return axios.get(`${PREFIX}/eventos-notificacoes`)
  },
  getTiposNotificacao() {
    return axios.get(`${PREFIX}/tipos-notificacao`)
  },
  getEventoNotificacaoPlaceholders(eventoId) {
    return axios.get(`${PREFIX}/placeholders-evento-notificacao/${eventoId}`)
  },
  getGruposNotificacoesPaginado(page, pageSize, filtros) {
    return axios.post(`${PREFIX}/grupos-notificacoes-paginado?page=${page}&pageSize=${pageSize}`, filtros)
  },
  getGruposNotificacoes() {
    return axios.get(`${PREFIX}/grupos-notificacoes`)
  },
}
